module.exports = __webpack_public_path__ + "img/004-network.b13dc8a7.png";